import { render, staticRenderFns } from "./AddSubAccount.vue?vue&type=template&id=5d05c32f&scoped=true&"
import script from "./AddSubAccount.vue?vue&type=script&lang=js&"
export * from "./AddSubAccount.vue?vue&type=script&lang=js&"
import style0 from "./AddSubAccount.vue?vue&type=style&index=0&id=5d05c32f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d05c32f",
  null
  
)

export default component.exports